module.exports = __webpack_public_path__ + "img/j3.32bf2bf6.png";